export const REPORT_VIEW_DESCRIPTOR = 'report';
